import type { TextI } from "tweenly"
import { renderStyles } from "tweenly"

/**
 * Aktualizuje styly na kopiích textů v continuous crawl tickeru
 * Kopie se vytváří pomocí cloneNode a nemají automaticky aktualizované styly
 */
export const updateTickerCopiesStyles = (textObjects: TextI[]) => {
    textObjects.forEach((textObject) => {
        // Najít všechny kopie tohoto textu
        const copies = document.querySelectorAll(`.item-container-copy [id="${textObject.id}"]`)

        if (copies.length > 0) {
            // Získat nové inline styly z objektu
            const newStyles = renderStyles(textObject, "inline")

            // Aplikovat styly na všechny kopie
            copies.forEach((copy) => {
                if (copy instanceof HTMLElement) {
                    Object.assign(copy.style, newStyles)
                }
            })
        }
    })
}
